let localStorageStatus = null;
export const isLocalStorageSupported = (win) => {
    if (localStorageStatus !== null) {
        return localStorageStatus;
    }
    try {
        if (typeof win === 'undefined' ||
            !('localStorage' in win) ||
            !win['localStorage'].getItem) {
            return false;
        }
        const testKey = '__test__';
        win['localStorage'].setItem(testKey, '1');
        win['localStorage'].removeItem(testKey);
        localStorageStatus = true;
        return true;
    }
    catch {
        localStorageStatus = false;
        return false;
    }
};
let indexedDBStatus = null;
const INDEXED_DB_ASYNC_PROBE_TIMEOUT_MS = 200;
export function isIndexedDBSupported(win, async = false) {
    if (indexedDBStatus !== null) {
        return async ? Promise.resolve(indexedDBStatus) : indexedDBStatus;
    }
    if (typeof win === 'undefined' || !win['indexedDB']) {
        indexedDBStatus = false;
        return async ? Promise.resolve(false) : false;
    }
    try {
        const request = win?.['indexedDB']?.open('testDB');
        if (async) {
            return new Promise((resolve) => {
                const timeoutId = setTimeout(() => {
                    indexedDBStatus = false;
                    resolve(false);
                }, INDEXED_DB_ASYNC_PROBE_TIMEOUT_MS);
                request.onsuccess = () => {
                    clearTimeout(timeoutId);
                    request.result.close();
                    win['indexedDB'].deleteDatabase('testDB');
                    indexedDBStatus = true;
                    resolve(true);
                };
                request.onerror = () => {
                    clearTimeout(timeoutId);
                    indexedDBStatus = false;
                    resolve(false);
                };
            });
        }
        request.onsuccess = () => {
            request.result.close();
            win['indexedDB'].deleteDatabase('testDB');
            indexedDBStatus = true;
        };
        request.onerror = () => {
            indexedDBStatus = false;
        };
        return true;
    }
    catch {
        indexedDBStatus = false;
        return async ? Promise.resolve(false) : false;
    }
}
//# sourceMappingURL=feature-detection.js.map